import axios from 'axios';

export const updateBrokerColorSchema = data => axios.post('/config/setting/ColorSettingClient/', data);

export const getBrokerColorSchema = () => axios.get('/config/setting/ColorSettingClient/');
